//TODO Change to : https://iamhosseindhv.com/notistack/demos
import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import {
  Done as SuccessIcon,
  InfoOutlined as InfoIcon,
  InfoOutlined as WarningIcon,
  ReportProblemOutlined as DangerIcon,
  NotificationsNone as NotificationsIcon,
  ShoppingCart as ShoppingCartIcon,
  LocalOffer as TicketIcon,
  BusinessCenter as DeliveredIcon,
  SmsFailed as FeedbackIcon,
  DiscFull as DiscIcon,
  Email as MessageIcon,
  Report as ReportIcon,
  Error as DefenceIcon,
  AccountBox as CustomerIcon,
  Done as ShippedIcon,
  Publish as UploadIcon,
  FileCopy as CopyIcon,
} from "@mui/icons-material";
import classnames from "classnames";
// import tinycolor from "tinycolor2";

// styles
import useStyles from "./styles";

//providers
import { useI18n } from "../../providers/I18n/I18n";

// components
import { Typography } from "../Wrappers/Wrappers";

// env
import { FRONT_END_DEBUG } from "../../providers/FeatureToggle/FeatureToggle";

const typesIcons = {
  success: <SuccessIcon />,
  info: <InfoIcon />,
  warning: <WarningIcon />,
  danger: <DangerIcon />,
  smsSuccess: <SuccessIcon />,
  "e-commerce": <ShoppingCartIcon />,
  notification: <NotificationsIcon />,
  offer: <TicketIcon />,
  error: <NotificationsIcon />,
  message: <MessageIcon />,
  feedback: <FeedbackIcon />,
  customer: <CustomerIcon />,
  shipped: <ShippedIcon />,
  delivered: <DeliveredIcon />,
  defence: <DefenceIcon />,
  report: <ReportIcon />,
  upload: <UploadIcon />,
  disc: <DiscIcon />,
};

export default function Notification({
  variant,
  type,
  message = "",
  messageId = "",
  ...props
}) {
  const classes = useStyles();
  const { t } = useI18n();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const characterOverflowLimit = 85;
  // const theme = useTheme();
  const icon = getIconByType(type);
  const iconWithStyles = React.cloneElement(icon, {
    classes: {
      root: classes.notificationIcon,
    },
    // style: {
    //   color:
    //     variant !== "contained" &&
    //     theme.palette[props.color] &&
    //     theme.palette[props.color].main,
    // },
  });

  useEffect(() => {
    const copyTimeout = setTimeout(() => {
      isCopied && setIsCopied(false);
    }, [3000]);
    return () => {
      clearTimeout(copyTimeout);
    };
  }, [isCopied]);

  const copyButton = (msg) => (
    <>
      <Tooltip
        title={t("copied")}
        arrow
        open={isCopied}
        placement="top"
        classes={{
          popper: classes.popper,
        }}
      >
        <CopyIcon
          data-testid="copyIcon"
          onClick={() => {
            navigator.clipboard.writeText(msg);
            setIsCopied(true);
          }}
          color="secondary"
        />
      </Tooltip>
    </>
  );

  const messageWithExpandText = () => {
    return isExpanded ? (
      <>
        {message} <br />
        <div
          aria-label="notification-see-less"
          className={classes.seeMore}
          onClick={() => setIsExpanded(false)}
        >
          {t("seeLess")}
        </div>
      </>
    ) : (
      <>
        {`${message.substring(0, characterOverflowLimit)}...`}
        <br />
        <span
          aria-label="notification-see-more"
          className={classes.seeMore}
          onClick={() => setIsExpanded(true)}
        >
          {t("seeMore")}
        </span>
      </>
    );
  };

  const isOverflowing = message.length > characterOverflowLimit;

  return (
    <div
      className={classnames(classes.notificationContainer, props.className, {
        [classes.notificationContained]: variant === "contained",
        [classes.expanded]: !!isExpanded,
        [classes.notificationContainedShadowless]: props.shadowless,
      })}
      // style={{
      //   backgroundColor:
      //     variant === "contained" &&
      //     theme.palette[props.backgroundColor] &&
      //     theme.palette[props.backgroundColor].main,
      // }}
    >
      <div
        className={classnames(classes.notificationIconContainer, {
          [classes.notificationIconContainerRounded]: variant === "rounded",
        })}
        // style={{
        //   backgroundColor:
        //     variant === "rounded" &&
        //     theme.palette[props.backgroundColor] &&
        //     tinycolor(theme.palette[props.backgroundColor].main)
        //       .setAlpha(0.15)
        //       .toRgbString(),
        // }}
      >
        {iconWithStyles}
      </div>
      <div className={classes.messageContainer}>
        <Typography
          component="span"
          // className={classnames({
          //   [classes.containedTypography]: variant === "contained",
          // })}
          // variant={props.typographyVariant}
          // size={variant !== "contained" && !props.typographyVariant && "md"}
        >
          {!isOverflowing ? message : messageWithExpandText()}
          {type === "danger" &&
            isExpanded &&
            FRONT_END_DEBUG &&
            copyButton(message)}
          {type === "smsSuccess" && copyButton(messageId)}
        </Typography>
      </div>
    </div>
  );
}

// ####################################################################
function getIconByType(type = "info") {
  return typesIcons[type];
}
